module.exports = __webpack_public_path__ + "img/kommune-121.a6ae5f9d.svg";